const controlsTemplate = `<div class="content-grid"><div class="col-12  side-scrolling-section__controls"><div class="side-scrolling-section__indicators indicators"></div><div class="side-scrolling-section__divder"></div><div class="side-scrolling-section__arrows"><button class="previous-button"></button><button class="next-button"></button></div></div></div>`;

class SideScrollingContainer extends HTMLElement {
  constructor() {
    super();

    this.scrollingSection = document.createElement("div");
    this.scrollingSection.classList.add("scrolling-section");
    this.scrollingSection.classList.add("no-scroll-bar");

    this.scrollingSection.innerHTML = this.innerHTML;

    this.innerHTML = "";

    this.scrollingSection.classList.add(this.dataset.scrollClass);

    console.log(this.dataset);

    this.appendChild(this.scrollingSection);

    this.controlsContainer = document.createElement("div");
    this.controlsContainer.classList.add("controls-container");
    this.controlsContainer.innerHTML = controlsTemplate;
    this.appendChild(this.controlsContainer);

    this.controls = this.controlsContainer.querySelector(
      ".side-scrolling-section__controls"
    );

    this.nextButton = this.controls.querySelector(".next-button");
    this.previousButton = this.controls.querySelector(".previous-button");

    this.handleScroll = this.handleScroll.bind(this);
    this.scrollingSection.addEventListener("scroll", this.handleScroll);

    this.currentSection = 0;

    this.nextButton.addEventListener("click", () => {
      console.log("nextButton", this.currentSection);
      this.gotoSection(this.currentSection + 1);
    });
    this.previousButton.addEventListener("click", () => {
      console.log("previousButton", this.currentSection);
      this.gotoSection(this.currentSection - 1);
    });

    this.reRender();
    this.handleScroll();

    setInterval(() => {
      this.reRender();
    }, 1000);
  }

  handleScroll() {
    const scrollLeft = this.scrollingSection.scrollLeft;

    this.currentSection = Math.round(scrollLeft / this.controls.offsetWidth);
    const scrollPercentage =
      scrollLeft /
      (this.scrollingSection.scrollWidth - this.scrollingSection.offsetWidth);

    console.log("scrollPercentage", scrollPercentage, this.currentSection);

    const indicators = this.controls.querySelectorAll(".indicator");

    if (scrollPercentage === 1) {
      this.currentSection = this.numberOfSections - 1;
    }

    if (scrollPercentage === 1) {
      this.nextButton.classList.add("disabled");
    } else {
      this.nextButton.classList.remove("disabled");
    }

    if (scrollPercentage === 0) {
      this.previousButton.classList.add("disabled");
    } else {
      this.previousButton.classList.remove("disabled");
    }

    indicators.forEach((indicator, index) => {
      if (index === this.currentSection) {
        indicator.classList.add("active");
      } else {
        indicator.classList.remove("active");
      }
    });
  }

  gotoSection(index) {
    console.log("gotoSection", index);

    this.scrollingSection.scrollTo({
      left: index * this.controls.offsetWidth,
      behavior: "smooth",
    });
  }

  reRender() {
    // number of scrolling sections

    //console.log(
    /// "this.scrollingSection.offsetWidth",
    // this.scrollingSection.offsetWidth
    // );
    //console.log("this.controls.offsetWidth", this.controls.offsetWidth);

    const gridWidth = this.controls.offsetWidth;
    const scrollWidth = this.scrollingSection.scrollWidth;
    const spacerWidth = this.offsetWidth - gridWidth;

    const numberOfSections = scrollWidth / (this.offsetWidth - spacerWidth);

    //console.log("spacerWidth", spacerWidth);
    //console.log("numberOfSections", numberOfSections);

    // add spacer width to scrolling section

    this.numberOfSections = Math.round(numberOfSections);

    this.controls.querySelector(".indicators").innerHTML = "";

    this.indicators = this.controls.querySelectorAll(".indicator");

    for (let i = 0; i < this.numberOfSections; i++) {
      const indicator = document.createElement("button");
      indicator.classList.add("indicator");

      if (this.currentSection === i) {
        indicator.classList.add("active");
      }
      indicator.addEventListener("click", () => {
        this.gotoSection(i);
      });
      this.controls.querySelector(".indicators").appendChild(indicator);
    }
  }
}

customElements.define("side-scrolling-section", SideScrollingContainer);
